import React, { useEffect, useState } from 'react'
import { Select,Form, Space} from 'antd';
import { useBnsBanBenListQuery } from '../../store/BnsKeJiApi';
import SubmoduleList from './SubmoduleList';

function SubmoduleSelect(props) {
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsBanBenListQuery({
        bbb_e_id:localStorage.getItem('e_id'),
        bbb_bg_id:props.bg_id,        
        bbb_bgn_id:props.bgn_id,
    },{skip:!props.bgn_id}); 
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bbb_id:key,bbb_name} = item;
                    return item = {value:key,label:bbb_name}
                })                
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    return (
        <Form.Item
            label={props.label}
            wrapperCol={props.wrapperCol}
            required={props.required}
            style={props.FormStyle}
        >
            <Space>
                <Form.Item
                    name={props.name}
                    style={{marginBottom:"0"}}
                >
                    <Select
                        options={list}
                        onChange={(e,f) => {props.onChange(e,f)}}
                        showSearch
                        optionFilterProp="label"
                        placeholder={props.placeholder}
                        style={props.style}
                    />
                </Form.Item>
                <SubmoduleList 
                    bg_id={props.bg_id}
                    bg_name={props.bg_name}
                    bgn_id={props.bgn_id}
                    bgn_name={props.bgn_name}
                />
            </Space>
        </Form.Item>
    )
}

export default SubmoduleSelect